import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "search-select" }
const _hoisted_2 = ["value", "placeholder", "disabled"]
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = {
  key: 1,
  class: "results-list"
}
const _hoisted_5 = ["onMousedown"]

import { ref, watch, nextTick, onMounted } from 'vue';
  
  interface Item {
    id: number | string;
    [key: string]: any;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchSelect',
  props: {
    items: {
      type: Array as () => Item[],
      default: () => []
    },
    loading: Boolean,
    itemText: {
      type: String,
      default: 'name'
    },
    placeholder: String,
    resetTrigger: Boolean,
    disabled: Boolean,
    initialValue: {
      type: String,
      default: "",
    },
  },
  emits: ['search', 'select'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const inputElement = ref<HTMLInputElement | null>(null)

  const props = __props;

  const emit = __emit;
  
  const searchQuery = ref('');
  const showResultsList = ref(false);
  
  const handleInput = (event: Event) => {
    const query = (event.target as HTMLInputElement).value;
    searchQuery.value = query;
    showResultsList.value = query.length > 0;
    emit('search', query);
  };

  // Nuevo método para resetear el input
  const resetInput = () => {
    searchQuery.value = '';
    if (inputElement.value) {
      inputElement.value.value = '';
    }
  };
  
  // Exponer métodos públicos
  __expose({
    resetInput
  });

  const selectItem = (item: any) => {
    searchQuery.value = item[props.itemText];
    showResultsList.value = false;
    emit('select', item);
  };
  
  const closeResults = () => {
    setTimeout(() => {
      showResultsList.value = false;
    }, 200);
  };
  
  const showResults = () => {
    if (searchQuery.value) {
      showResultsList.value = true;
    }
  };

  watch(() => props.resetTrigger, () => {
    searchQuery.value = '';
    if (inputElement.value) {
      inputElement.value.value = '';
    }
  });

  // Cargar valor inicial al montar
  onMounted(() => {
    if (props.initialValue) {
      searchQuery.value = props.initialValue;
      if (inputElement.value) {
        inputElement.value.value = props.initialValue;
      }
    }
  });

  // Observar cambios en initialValue
  watch(() => props.initialValue, (newValue) => {
    if (newValue !== null && newValue !== undefined) {
      searchQuery.value = newValue;
      if (inputElement.value) {
        inputElement.value.value = newValue;
      }
    }
  }, { immediate: true }); // Añadir immediate: true
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      value: searchQuery.value,
      onInput: handleInput,
      onBlur: closeResults,
      onFocus: showResults,
      placeholder: __props.placeholder,
      class: "form-control",
      disabled: __props.disabled,
      ref_key: "inputElement",
      ref: inputElement
    }, null, 40, _hoisted_2),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Buscando..."))
      : _createCommentVNode("", true),
    (showResultsList.value && __props.items.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              onMousedown: ($event: any) => (selectItem(item)),
              class: "result-item"
            }, _toDisplayString(item[__props.itemText]), 41, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})